// src/components/PeoplePlan/EmployeeManagement/hooks/useNotifications.js
import { useState } from 'react';

export const useNotifications = () => {
  const [notification, setNotification] = useState({
    show: false,
    message: "",
    type: "", // 'success' | 'error' | 'warning'
  });

  const showNotification = (message, type = 'success', duration = 5000) => {
    setNotification({
      show: true,
      message,
      type,
    });

    if (duration > 0) {
      setTimeout(() => {
        hideNotification();
      }, duration);
    }
  };

  const hideNotification = () => {
    setNotification({
      show: false,
      message: "",
      type: "",
    });
  };

  return {
    notification,
    showNotification,
    hideNotification,
  };
};